import Contact from "../../Models/Contact";

export const GET_CONTACTS = "Contact/getContacts";
export const GET_CONTACTS_BY_CLIENT = "Contact/getContactsByClient";
export const SAVE_CONTACT = "Contact/saveContact";
export const DELETE_CONTACT = "Contact/deleteContact";

export interface ContactReducerType {
  contacts: Contact[],
  contactsByClient: Contact[]
}

export interface ISearchContact {
  name?: string;
  last_name?: string;
  phone?: string;
  cellphone?: string;
  customer?: string;
  searchByClient?: boolean;
}

export  interface ISaveContact {
  contact: Contact;
  refreshContacts: boolean;
}
